<template>
  <div class="create-acivity">
    <div class="acivity-right">
      <div style="width: 100%; height: 100%;">
        <div class="tab-tit">
          <ul>
            <li @click="curId = 0" :class="{'cur' : curId >= 0}" style="width:60px">
              <img src="../../assets/images/activity_tab1.png">
              <p>选择受众</p>
            </li>
            <li @click="curId = 1" :class="{'cur' : curId >= 1}">
              <img src="../../assets/images/activity_tab2.png" v-if="curId >= 1">
              <img src="../../assets/images/activity_tab2_1.png" v-else>
              <span></span>
              <p>配置活动</p>
            </li>
            <li @click="curId = 2" :class="{'cur' : curId >= 2}">
              <img src="../../assets/images/activity_tab3.png" v-if="curId >= 2">
              <img src="../../assets/images/activity_tab3_1.png" v-else>
              <span></span>
              <p style="width: 240px;">完成</p>
            </li>
          </ul>
        </div>
        <div v-if="curId === 0" class="tab-con">
          <el-form :inline="false" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="70px">
            <el-form-item label="触发条件" prop="activity_type" style="margin-bottom: 0px">
              <span style="font-size: 14px;color: #606266;">扫描瓶盖内二维码</span>
            </el-form-item>
            <el-form-item label="布奖名称" prop="activity_type" style="margin-bottom: 0px">
              <el-input v-model="formInline.name" placeholder="请输入活动名称（不能超过50字）" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="布奖条件" prop="activity_type" style="margin-bottom: 0px">
            </el-form-item>
          </el-form>
          <div class="higher-search-analyse">
          <!--大的查询集合-->
          <div class="big-terms-content">
            <!--大的查询集合switch-->
            <div class="switch-line" style="left: 5%;" v-if="conditionGroup.length > 1"></div>
            <div class="big-switch-contents" v-if="conditionGroup.length > 1" style="top: calc(50% - 27px); width: 10%;">
              <el-switch
                style="display: block"
                v-model="outOperator1"
                active-color="#1980FF"
                inactive-color="#ff4949"
                active-text="且"
                inactive-value="or"
                active-value="and"
                @change="update"
                class="big-switch"
                inactive-text="或">
              </el-switch>
            </div>
            <div class="condition-content">
              <!--大的查询集合条件组-->
              <div class="big-term-content" style="width: 94%;" v-for="(one, i) in conditionGroup" :key="i">
                <!--小的查询集合-->
                <div class="search-wrap" style="overflow:hidden; width: 850px; padding-left: 20px">
                  <div
                    class=""
                    :class="one | formatCusHigherSearchLine"
                    v-if="one.terms.length > 1">
                  </div>
                  <div
                    class=""
                    :class="one | formatCusHigherSearchAndOr"
                    v-if="one.terms.length > 1">
                    <el-switch
                      style="display: block; left: -20%;"
                      v-model="one.inOperator"
                      active-color="#1980FF"
                      inactive-color="#ff4949"
                      @change="update"
                      active-text="且"
                      inactive-value="or"
                      active-value="and"
                      class="switch"
                      inactive-text="或">
                    </el-switch>
                  </div>
                  <div class="search-terms-content" style="width: 720px;">
                    <div v-for="(item, index) in one.terms" :key="index" class="term-item">
                      <div class="select-content" style="text-align: left">
                        <el-select v-model="item.value" placeholder="请选择">
                          <el-option
                            v-for="item in selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <div v-if="item.value === 'outgoingTime'">
                          <el-date-picker
                            v-model="item.startValue"
                            type="datetime"
                            class="dateTimePicker"
                            @change="update"
                            value-format="yyyy-MM-dd"
                            placeholder="选择开始日期">
                          </el-date-picker>
                          <span
                            style="padding: 0 6px">至
                          </span>
                          <el-date-picker
                            v-model="item.endValue"
                            type="datetime"
                            class="dateTimePicker"
                            @change="update"
                            value-format="yyyy-MM-dd"
                            placeholder="选择结束日期">
                          </el-date-picker>
                        </div>
                        <div v-if="item.value === 'distributor'">
                          <el-select v-model="item.distributor" placeholder="请选择经销商">
                            <el-option
                              v-for="item in distributorOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <el-select v-model="item.batches" placeholder="请选择批次">
                            <el-option
                              v-for="item in batchesOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                        <div v-if="item.value === 'commodity'" class="item-content">
                          <el-select v-model="item.product" placeholder="请选择">
                            <el-option
                              v-for="item in productOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <el-radio-group v-model="item.radio" class="radio-content">
                            <el-radio :label="1">仅限选择商品参与</el-radio>
                            <el-radio :label="2">排除以上商品参与</el-radio>
                          </el-radio-group>
                        </div>
                        <div v-if="item.value === 'group'" class="item-content">
                          <el-select v-model="item.groupValue" placeholder="请选择">
                            <el-option
                              v-for="item in groupOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <span @click="searchDialogAction" style="line-height: 35px;">
                            <i class="iconfont icon-shaixuan analyse-search-icon"></i>
                            <div class="op-link" style="margin: 0;font-size: 14px">选择人群筛选条件
                            </div>
                          </span>
                        </div>
                        <div v-if="item.value === 'area'" class="item-content">
                          <el-cascader
                            size="large"
                            :options="addressOptions"
                            v-model="item.address"
                            @change="update">
                          </el-cascader>
                        </div>
                        <div v-if="item.value === 'codeSegment'" class="item-content">
                          <el-select v-model="item.codevalue" placeholder="请选择">
                            <el-option
                              v-for="item in codeSegmentOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                        <div class="remove-btn" style="margin-left: 9px" @click="removeTermItem(index, i)">
                          <i class="el-icon-error" style="color: #ccc;font-size: 15px" title="删除当前条件"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="add-new-terms" style="margin-top: 0;padding-top: 0" v-if="one.terms.length > 0 && termsNum <= 7">
                  <div class="add-new-term-btn" style="margin-left: 45%" @click="addNewTerm(i)">
                    <i class="el-icon-circle-plus-outline"></i>
                    增加一个条件
                  </div>
                </div>
              </div>
            </div>
            <!--增加一组条件按钮-->
            <div class="add-one-group-terms" v-if="termsNum <= 7" style="margin-left: 90px;width: 874px;background-color: #ecf2fb;">
              <div class="add-one-group-terms-btn" style="margin: 0 auto; color: #1890FF;" @click="addNewTermGroup">
                <i class="el-icon-circle-plus-outline"></i>
                  增加一组条件
              </div>
            </div>
            </div>
          </div>
          <div style="text-align: center; width: 260px;margin: 0 auto 20px;height: 36px">
            <el-button class="dialog-confirm-btn" type="primary" style="margin-top: 20px; margin-bottom: 30px;" @click="curId = 1">
              下一步
            </el-button>
          </div>
        </div>
      <div v-if="curId === 1" class="tab-con">
        <el-form :inline="false" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="70px">
        <div class="new_name">指定营销活动 </div>
        <el-form-item label="营销活动">
          <el-select v-model="formInline.marketing" placeholder="请选择">
            <el-option
              v-for="item in marketingOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扫码模板">
          <el-select v-model="formInline.scan" placeholder="请选择">
            <el-option
              v-for="item in scanOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="new_name">
          终端返利
          <el-switch
            :active-value="1"
            :inactive-value="2"
            v-model="formInline.strategystate1"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </div>
        <el-form-item label="返利比例">
          <el-input v-model="formInline.rebate_ratio" controls-position="right" :min="1" class="rebate-ratio">
          </el-input>%
          <el-tooltip
            class="item"
            effect="dark"
            content="即消费者扫码获得红包后，终端店可以获得返利的比例，如消费者获得红包10元，10%的返利则是1元" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <div class="new_name">
          设置标签
          <el-switch
            :active-value="1"
            :inactive-value="2"
            v-model="formInline.strategystate2"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </div>
        <el-form-item label="">
          <el-radio-group v-model="formInline.activeName" style="margin-bottom: 5px;">
            <el-radio-button label="ADD">添加标签</el-radio-button>
            <el-radio-button label="DELETE">移除标签</el-radio-button>
          </el-radio-group>
          <tags-table
            v-if="formInline.activeName === 'ADD'"
            v-model="formInline.tagsArray"
            :modelId="modelId">
          </tags-table>
          <delete-tags-table
            v-if="formInline.activeName === 'DELETE'"
            v-model="formInline.tagsArray"
            :modelId="modelId">
          </delete-tags-table>
        </el-form-item>
        <div class="new_name">
          设置群组
          <el-switch
            :active-value="1"
            :inactive-value="2"
            v-model="formInline.strategystate3"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </div>
        <el-form-item >
          <div style="display: flex; justify-content: flex-start; flex-direction: column;">
            <el-radio-group v-model="formInline.activeName1" style="margin-bottom: 5px;">
              <el-radio-button label="ADD1">添加群组</el-radio-button>
              <el-radio-button label="DELETE1">移除群组</el-radio-button>
            </el-radio-group>
            <el-select v-model="formInline.groupVal" placeholder="请选择" v-if="formInline.activeName1 === 'ADD1'">
              <el-option
                v-for="item in groupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="formInline.groupVal" placeholder="请选择" v-if="formInline.activeName1 === 'DELETE1'">
              <el-option
                v-for="item in groupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item class="button-content">
          <el-button class="dialog-confirm-btn" type="primary" @click="curId = 2" style="margin-right: 85px;margin-left: 10px">下一步</el-button>
            <el-button class="dialog-cancel-btn" @click="curId = 0" style="margin-left: 55px">上一步
          </el-button>
        </el-form-item>
          </el-form>
          </div>
          <div v-if="curId === 2" class="tab-con">
          <el-form :inline="false" class="acivity-prize-form" style="text-align: center;">
            <div class="finish-content">
              <img src="../../assets/images/WechatIMG392.png">
              操作成功
            </div>
          </el-form>
          </div>
          <div v-if="curId === 4" style="width: 95%;overflow-x: auto;margin-left: 5%;">
            <div style="display: flex;padding-top:20px;min-width:1087px;">
            </div>
          <div style="width:190px;margin: 0 0 20px 40%;" class="interface_btn">
            <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="addActivitys()">保存</el-button>
            <el-button class="dialog-cancel-btn" @click="curId = 3">上一步</el-button>
          </div>
        </div>
      </div>
    </div>
    <!--筛选弹窗-->
    <el-dialog class="cellDialog analyse-dialog" title="人群筛选条件" :visible.sync="searchDialog" width="1090px">
      <higher-search-audiences
        :modelId="modelId"
        :isAnalyse="isAnalyse"
        class="common-search-formtype customer-manage-higher-search group-item-style high-search-cascader analyse-high-search"
        :forSonTerms="forSonTerms"
        v-bind:allRelationship="allRelationship"
        @change="getAllTerms"
        style="margin-top: 10px">
      </higher-search-audiences>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" style="margin-left: 20px" @click="searchDialog = false">
          取 消
        </el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="confirmSearchTerms" style="margin-right: 32px">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import HigherSearchAudiences from './../common/higher-search-audiences.vue'
import { API_HOST } from '@/api/local'
import { regionDataPlus, CodeToText } from 'element-china-area-data'
import { getWechatPublicListForNode, getCustomerSourceListForWepage, getActivitysDetail, editActivitys } from '@/api/activity.js'
import { getAudGroupList, getCusEventList } from '@/api/set.js'
import deleteTagsTable from './../common/delete-tags-table.vue'
import tagsTable from './../common/tags-table.vue'
export default {
  name: 'createPrize',
  data() {
    return {
      scanOptions: [
        {
          value: '1',
          label: '大转盘'
        },
        {
          value: '4',
          label: '砸酒坛'
        },
        {
          value: '5',
          label: '砸金蛋'
        }
      ],
      marketingOptions: [
        {
          value: '7',
          label: '酒鬼湘泉布奖活动'
        },
        {
          value: '8',
          label: '山东地区布奖活动'
        },
        {
          value: '9',
          label: '30-40岁男客户布奖'
        }
      ],
      batchesOptions: [
        {
          value: '1',
          label: '10001'
        },
        {
          value: '2',
          label: '10002'
        },
        {
          value: '3',
          label: '10003'
        },
        {
          value: '4',
          label: '10004'
        },
        {
          value: '5',
          label: '10005'
        },
        {
          value: '6',
          label: '10006'
        }
      ],
      distributorOptions: [
        {
          value: '1',
          label: '济南经销一部'
        },
        {
          value: '2',
          label: '济南经销二部'
        },
        {
          value: '3',
          label: '济南经销三部'
        },
        {
          value: '4',
          label: '济南经销四部'
        },
        {
          value: '5',
          label: '济南经销五部'
        },
        {
          value: '6',
          label: '济南经销六部'
        },
        {
          value: '7',
          label: '经销商'
        }
      ],
      outOperator1: 'and',
      codeSegmentOptions: [
        {
          value: '121',
          label: '121'
        },
        {
          value: '122',
          label: '122'
        },
        {
          value: '123',
          label: '123'
        },
        {
          value: '124',
          label: '124'
        },
        {
          value: '125',
          label: '125'
        }
      ],
      addressOptions: regionDataPlus,
      is_show_analyse_show: false,
      groupOptions: [
        {
          value: '1',
          label: '莱芜地区客户'
        },
        {
          value: '2',
          label: '30-40岁男客户'
        },
        {
          value: '3',
          label: '初始来源为微信公众号'
        },
        {
          value: '4',
          label: '当前等级未知'
        },
        {
          value: '5',
          label: '济南地区客户'
        },
        {
          value: '6',
          label: '5月关注微信公众号'
        },
        {
          value: '7',
          label: '扫描瓶盖内码3次以上'
        }
      ],
      productOptions: [
        {
          value: '1',
          label: '酒鬼湘泉老坛'
        },
        {
          value: '2',
          label: '酒鬼原浆酒'
        },
        {
          value: '3',
          label: '酒鬼珍藏特酿'
        },
        {
          value: '4',
          label: '酒鬼馥郁天成'
        },
        {
          value: '5',
          label: '酒鬼湘泉简优'
        },
        {
          value: '6',
          label: '精品酒鬼酒'
        },
        {
          value: '7',
          label: '酒鬼酒(妙造)'
        },
        {
          value: '8',
          label: '酒鬼黄坛'
        },
        {
          value: '9',
          label: '悠悠湘泉小酒'
        },
        {
          value: '10',
          label: '30-40岁男客户布奖'
        }
      ],
      tagsArray: ['湘泉', 'sss'],
      activeName: 'ADD',
      activeName1: 'ADD1',
      conditionGroup: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '',
              relationship: '',
              relationOptions: [],
              value: null,
              option: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              selectedOptions: ['attr', '']
            }
          ]
        }
      ],
      modelId: 328,
      forSonTerms: [],
      isAnalyse: false,
      searchDialog: false,
      allRelationship: '',
      radio: '',
      selectOptions: [
        {
          value: 'outgoingTime',
          label: '出库时间'
        },
        {
          value: 'distributor',
          label: '经销商'
        },
        {
          value: 'commodity',
          label: '商品'
        },
        {
          value: 'group',
          label: '群组'
        },
        {
          value: 'area',
          label: '地区'
        },
        {
          value: 'codeSegment',
          label: '码段'
        }
      ],
      value: '',
      outOperator: '',
      termsNum: [],
      realAllTerms: {
        allRelationship: 'and',
        termsGroup: [
          {
            inOperator: 'and',
            terms: [
              {
                secAttr: '',
                startValue: '',
                endValue: '',
                attr_label: '',
                attr: 'attr',
                relationship: '',
                relationOptions: [
                  {
                    value: 'equal',
                    label: '等于'
                  }, {
                    value: 'not_equal',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'not_contain',
                    label: '不包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not_empty',
                    label: '不为空'
                  }
                ],
                gridNum: 3,
                visible2: false,
                start_end_time: '昨日',
                happenedTimes: '',
                happenedTimes_from: '',
                happenedTimes_to: '',
                gtele_start: '',
                gtele_end: '',
                value: null,
                qrcode: null,
                eventCheckbox1: false, // 选择受众事件的checkbox
                eventCheckbox2: false,
                eventCheckbox3: false,
                eventSearchDateSelect: 'yesterday', // 选择受众事件选中起止时间选择框
                eventSearchDateSelectStart: '',
                eventSearchDateSelectEnd: '',
                eventSearchTimesSelect: '', // 选择受众事件选中发生次数选择框
                eventAttributeOptions: [ // 选择受众事件选中事件属性
                  {
                    attributeSelect: '',
                    attributeRelation: '',
                    attributeValue: ''
                  }
                ],
                selectedOptions: ['attr', '']
              }
            ]
          }
        ]
      },
      termsGroup: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '',
              relationship: '',
              relationOptions: [],
              value: null,
              option: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              selectedOptions: ['attr', '']
            }
          ]
        }
      ],
      addressShow: false, // 收货地址界面配置
      basicData: false,
      basicSenior: false,
      prizeArea: false,
      timeSlot: false,
      options: regionDataPlus,
      selectedOptions: [],
      curId: 0,
      interfaceId: 0,
      dateoutbound: [],
      sources: [],
      activetyOptions: [{
        value: 1,
        label: '二维码布奖活动'
      }],
      level: ['一等奖', '二等奖', '三等奖', '四等奖', '五等奖', '六等奖'],
      date: [],
      formInline: {
        tagsArray: ['sss'],
        // template_id: this.$route.query.template_id,
        // date: [],
        // activity_type: '',
        // name: '',
        // start_time: '',
        // end_time: '',
        // outbound_begin_time: '',
        // outbound_end_time: '',
        // source_content: '',
        // province: '',
        // city: '',
        // district: '',
        // goods: '',
        // goods_status: 0,
        // draw_num: 1,
        // everyday_draw_num: 1,
        // winning_prize_num: 1,
        // assistance_prize_num: 1,
        // share_prize_num: 1,
        // is_question: 0,
        // set_up: 1,
        // receive_way: 1,
        // lottery_num: 1,
        // source_id: '',
        // wechat_share: 1,
        // public_id: '',
        // // cover_img: '',
        // // background_img: '',
        // share_img: '',
        // share_title: '',
        // share_description: '',
        // assistance_status: 2,
        // everyactivity_assistance_prize_num: 1,
        // everyday_assistance_prize_num: 1,
        // assistance_prize_status: 0,
        // everyday_assistance_num: 1,
        // everyday_assistance_one_num: 1,
        // // 预计人数
        // active_number: '',
        // assistance_active_number: '',
        // // active_img: '',
        // template: '',
        // draw_type: 1,
        // description: '',
        // show_num: 0,
        // strategystate: 2,
        // strategyareastate: 2,
        // strategytimestate: 2,
        // strategy: [],
        // strategyarea: [],
        // strategytime: [],
        // assistance_prize: [],
        // prize: [{
        //   prize_level: 1,
        //   prize_type: 1,
        //   prize_name: '',
        //   prize_number: '',
        //   prize_num: 1,
        //   prize_num_show: '',
        //   prize_max_money: '',
        //   prize_min_money: ''
        // }],
        // background_img: '',
        // cover_img: '',
        // active_img: '',
        // active_btn_img: '',
        // prizeshow_img: '',
        // intro_img: '',
        // getprize_img: '',
        // getprize_btn_img: '',
        // noprize_img: '',
        // assistance_share_btn_img: '',
        // receiveprize_bg_img: '',
        // receiveprize_btn_img: '',
        // assistance_img: '',
        // assistance_btn_img: '',
        // qrcode_img: '',
        // qrcode_bg_img: '',
        // preheat_bg_img: '',
        // preheat_btn_img: '',
        // is_show_preintro: 0,
        // preintro_days: ''
      },
      publicOptions: [],
      num8: 1,
      tableData: [{
        index: '1'
      }],
      prizeOptions: [
        {
          value: 1,
          label: '实物'
        },
        {
          value: 2,
          label: '红包'
        }
      ],
      cycleOptions: [
        {
          value: 1,
          text: 'day',
          label: '每天'
        },
        {
          value: 2,
          text: 'activityday',
          label: '活动期间'
        }
      ],
      cycleTimeOptions: [
        {
          value: 1,
          text: 'day',
          label: '每天'
        },
        {
          value: 2,
          text: 'custom',
          label: '指定日期'
        }
      ],
      prizeLevelOptions: [
        {
          value: 1,
          label: '一等奖'
        },
        {
          value: 2,
          label: '二等奖'
        }
      ],
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ],
        source_content: [
          { required: true, message: '请输入来源说明', trigger: 'blur' }
        ],
        source_id: [
          { required: true, message: '请选择客户来源', trigger: 'blur' }
        ],
        public_id: [
          { required: true, message: '请选择公众号', trigger: 'blur' }
        ]
      },
      events: [],
      everydayNumMax: 1,
      lotteryNumMax: 1,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      pickerAppointedOptions: {
        disabledDate: (time) => {
          let _this = this
          let start = new Date(Date.parse(_this.formInline.start_time.replace(/-/g, '/')))
          let end = new Date(Date.parse(_this.formInline.end_time.replace(/-/g, '/')))
          return !((time.getTime() >= start) && (time.getTime() <= end))
        }
      },
      lotteryPeriod: [{
        value: 'day',
        label: '每天'
      }]
    }
  },
  methods: {
    loadEvent() {
      getCusEventList(1, 0, '').then(res => {
        let data = res.data.result.list
        for (let i of data) {
          this.events[i.identity] = i.name
        }
      })
    },
    handleClick() {
    },
    // 删除当前这条查询条件
    removeTermItem(index, i) {
      this.conditionGroup[i].terms.splice(index, 1)
      if (this.conditionGroup[i].terms.length === 0) {
        this.termsGroup.splice(i, 1)
      }
    },
    // 添加一组查询条件
    addNewTermGroup() {
      console.log('conditionGroup', this.conditionGroup)
      this.conditionGroup.push({
        inOperator: 'and',
        terms: [
          {
            value: null,
            option: [],
            startValue: '',
            endValue: '',
            selectedOptions: ['attr', '']
          }
        ]
      })
    },
    // 确定查询条件
    confirmSearchTerms() {
      // 判断是否为空
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].selectedOptions[1] === '') {
              _g.toastMsg('error', '受众属性-具体属性不能为空')
              // this.$message.error('sssss')
              return
            }
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断受众属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].startValue === '') {
                    _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].endValue === '' || item.terms[j].endValue === null) {
                    _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断受众画像标签是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'aud_portary') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '受众画像-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断受众事件是否为空
          if (item.terms[j].attr === 'event') {
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              for (let yi of item.terms[j].eventAttrOptions) {
                if (yi.attributeContent === '') {
                  _g.toastMsg('error', '受众事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                  return
                }
                if (yi.attributeRelation === '') {
                  _g.toastMsg('error', '受众事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                  return
                }
                if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                  if (yi.attributeValue === '') {
                    _g.toastMsg('error', '受众事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                    return
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (!item.terms[j].eventDateStart || !item.terms[j].eventDateEnd) {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断受众身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '受众身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关受众关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '受众关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                  _g.toastMsg('error', '受众关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      this.searchDialog = false
      this.is_show_analyse_show = true
      sessionStorage.setItem(this.formInline.modelId, JSON.stringify(this.allTerms))
      this.realAllTerms = JSON.parse(JSON.stringify(this.allTerms))
      this.filterName = '修改人群筛选条件'
    },
    // 获取子组件的查询条件
    getAllTerms(value) {
      this.allTerms = value
    },
    searchDialogAction() {
      this.searchDialog = true
    },
    addNewTerm(i) {
      this.conditionGroup[i].terms.push({
        attr: 'attr',
        attr_label: '',
        relationship: '',
        relationOptions: [],
        value: null,
        option: [],
        startValue: '',
        endValue: '',
        eventAttrOptions: [
          {
            attributeContent: '',
            relationOptions: [],
            sources: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attr_type: '',
            attr_identity: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValueStart: '',
            attributeValueEnd: '',
            attributeValue: ''
          }
        ],
        eventLimitTime: false,
        eventLimitTimes: false,
        eventLimitAttr: false,
        selectedOptions: ['attr', '']
      })
      console.log('this.conditionGroup', this.conditionGroup)
    },
    update() {},
    // 判断时候有实物奖品
    addressShowFun() {
    },
    assistanceStatusChange() {},
    wechatShareChange() {},
    handleChange0(value) {},
    // 删除策略
    deleteStrategyRow(item) {
      let index = this.formInline.strategy.indexOf(item)
      this.formInline.strategy.splice(index, 1)
    },
    deleteStrategyRow4(item) {
      let index = this.formInline.strategyarea.indexOf(item)
      this.formInline.strategyarea.splice(index, 1)
    },
    deleteStrategyRow5(item) {
      let index = this.formInline.strategytime.indexOf(item)
      this.formInline.strategytime.splice(index, 1)
    },
    deleteRow(index, rows) {
      if (this.formInline.prize.length <= 1) {
        _g.toastMsg('error', '至少要有一个奖项')
        return
      }
      rows.splice(index, 1)
    },
    deleteAssistanceRow(index, rows) {
      if (this.formInline.assistance_prize.length <= 1) {
        _g.toastMsg('error', '至少要有一个奖项')
        return
      }
      rows.splice(index, 1)
    },
    addActivitys() {},
    dateChange(value) {},
    addAssistancePrizeAction() {},
    addNumberAwards() {},
    addPrizeArea() {},
    addtimeSlotArea() {},
    handleAvatarSuccess(res, file) {},
    beforeAvatarUpload(file) {},
    handlePrizeSuccess(res, file, index) {},
    handleAssistancePrizeSuccess(res, file, index) {
    },
    handlePrizeRemove(name, index) {
    },
    handleRemove(index) {
    },
    // 界面图片上传
    handleInterfaceSuccess(res, file, index) {},
    handleInterfaceSuccess1(res, file, index) {},
    getPublicList() {},
    // 获取客户来源
    getSourceList() {},
    getData() {},
    interfaceFun(id) {},
  },
  components: {
    'higher-search-audiences': HigherSearchAudiences,
    'delete-tags-table': deleteTagsTable,
    'tags-table': tagsTable
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.getPublicList()
    this.getSourceList()
    if (this.$route.query.id === '酒鬼湘泉老坛布奖') {
      this.formInline = {
        name: '酒鬼湘泉老坛布奖',
        marketing: '7',
        activeName1: 'ADD1',
        scan: '4',
        rebate_ratio: '1',
        activeName: 'ADD',
        tagsArray: ['湘泉', 'sss']
      }
      this.conditionGroup = [
        {
          inOperator: 'and',
          terms: [
            {
              value: 'commodity',
              product: '5',
              radio: 1
            }
          ]
        }
      ]
    }
    if (this.$route.query.id === '30-40岁男客户布奖') {
      this.formInline = {
        name: '30-40岁男客户布奖',
        marketing: '9',
        scan: '5',
        groupVal: '2',
        rebate_ratio: '1',
        activeName: 'ADD',
        activeName1: 'ADD1',
        tagsArray: ['5月出库中奖']
      }
      this.conditionGroup = [
        {
          inOperator: 'and',
          terms: [
            {
              selectedOptions: ['attr', ''],
              value: 'group',
              product: '5',
              radio: 1,
              groupValue: '2'
            },
            {
              selectedOptions: ['attr', ''],
              value: 'outgoingTime',
              startValue: '2019-05-01 00:00:00',
              endValue: '2019-05-30 00:00:00',
              product: '5',
              radio: 1,
              groupValue: '2'
            }
          ]
        }
      ]
      console.log('this.conditionGroup', this.conditionGroup)
    }
    if (this.$route.query.id === '济南经销一部布奖') {
      this.formInline = {
        name: '济南经销一部布奖',
        marketing: '8',
        groupVal: '5',
        scan: '5',
        rebate_ratio: '1',
        activeName: 'ADD',
        activeName1: 'ADD1',
        tagsArray: ['济南经销一部客户'],
        tagsArrays: ['济南地区客户']
      }
      this.conditionGroup = [
        {
          inOperator: 'and',
          terms: [
            {
              selectedOptions: ['attr', ''],
              value: 'distributor',
              distributor: '7',
              batches: '1',
              groupValue: '2'
            }
          ]
        }
      ]
      console.log('this.conditionGroup', this.formInline)
    }
    if (this.$route.query.id === '山东省莱芜地区布奖') {
      this.formInline = {
        name: '山东省莱芜地区布奖',
        marketing: '8',
        scan: '5',
        rebate_ratio: '1',
        activeName: 'ADD',
        tagsArray: [],
        activeName1: 'ADD1',
        groupVal: '1'
      }
      this.conditionGroup = [
        {
          inOperator: 'and',
          terms: [
            {
              selectedOptions: ['attr', ''],
              value: 'area',
              product: '5',
              radio: 1,
              address: ['370000', '371200', ''],
              groupValue: '2'
            }
          ]
        }
      ]
      console.log('this.conditionGroup', this.conditionGroup)
    }
  }
}

</script>
<style scoped>
.create-acivity {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: calc(100% - 40px);
  background: #fff;
  margin: 20px auto 0;
  overflow-x: hidden;
}
.wechat_share {
  margin: 0;
  line-height: 20px;
}
.new_name {
  width: 100%;
  border-bottom: 1px dotted #D1D1D1;
  line-height: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  text-align: left;
}
.cover_img {
  border: 1px solid #d4d4d4;
  padding: 10px;
  border-radius: 5px;

}
.avatar-uploader {
  margin: 8px 0 0 8px;
}
.avatar-uploader-icon {
  font-size: 22px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 40px;
  height: 40px;
  display: block;
  margin-left: 20px;
}

.acivity-right {
  margin: 0 auto;
  width: 100%;
  /*height: 800px;*/
  align-items: center;
  display: block;
  justify-content: center;
  /*margin-left: -30px;*/
}

.mobile-img {
  position: absolute;
}

.scrol-image {
  /*margin-left: 130px;*/
}

.liuhai {
  position: absolute;
  top: 113px;
  z-index: 100;
}

.scrol-image,
.scrol-image .el-carousel__item {
  height: 575px;
  width: 266px;
  border-radius: 26px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.tab-tit {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
  overflow: hidden;
  border-bottom: 1px solid #E7E7E7;
  text-align: center;
}
.tab-tit .cur {
  /*background: #4486ff;*/
  color: #1980FF;
}

.tab-tit .line,
.saveData .line {
  width: 90%;
  margin: 2% auto;
  border: 0.5px dashed #d2d2d2;
}

.tab-tit a {
  cursor: pointer;
  display: block;
  float: left;
  width: 130px;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  text-align: center;
  background: #fff;
  color: #333;
  border: 1px solid #1890FF;
}
.acivity-content-form {
  width: 764px;
  text-align: left;
  margin: 0 auto;
}
.acivity-setting-form {
  width: 534px;
  text-align: center;
  margin: auto;
}

.acivity-prize-form {
  /*text-align: center;*/
  /*margin: 0 auto;*/
  width: 100%;
}

.acivity-content-form .el-form-item__content {
  width: 300px;
}

.acivity-content-form p {
  margin: 0px;
  line-height: 20px;
  text-align: left;
  color: #999;
  font-size: 12px;
}

.prize-count {
  width: 100px;
}

.prize-count-special {
  width: 90px;
}

.prize-percent {
  width: 80px;
}

.prize-percent .el-input {
  width: 60px;
}

.prize-percent .el-input__inner {
  width: 60px;
  height: 36px;
}

.home-pic {
  width: 100%;
  height: 100%;
}

.avatar-pic {
  height: 110px;
  width: 327px;
  display: block;
}

.prize-pic {
  height: 110px;
  width: 110px;
  display: block;
}

.button-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-top: 20px;
}

.new-add-setting {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: left;
  /*margin-left: 30px;*/
  /*margin-top: 30px;*/
}

.new-add-table {
  width: 100%;
  margin-top: 10px;
}

.tags-text-item {
  width: 200px;
}

.tip-view {
  margin-left: 20px;
  margin-top: 10px;
  text-align: left;
  font-size: 14px;
  color: #666;
}

.money-span {
  display: block;
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
}

@media screen and (min-width: 1600px) {
  .acivity-left {
      width: 35%;
      justify-content: flex-end;
      margin-right: 100px;
  }

  .mobile-img {
      right: -23px;
  }

  .liuhai {
      right: 60px;
  }
}

/*界面配置*/
.interface_tab {
  width: 150px;
  text-align: left;
}

.interface_tab ul {
  padding: 0;
}

.interface_tab li {
  list-style: none;
  line-height: 60px;
  cursor: pointer;
}

.interface {
  background: #E5E5E5;
  width: 365px;
  height: 610px;
  border-radius: 35px;
  overflow-x: hidden;
}

.interface_img {
  background-color: #fff;
  width: 325px;
  margin: 31px auto 32px;
  height: 547px;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.interface_con {
  background: url(../../assets/images/interface_bg.png) no-repeat;
  background-size: 100% 100%;
  min-height: 547px;
  box-sizing: border-box;
  border: 1px solid transparent;
}

.interface_hei {
  min-height: 979px;
}

.interfaceId {
  color: #1980FF;
}

.interface_form {
  min-width: 350px;
  margin-left: 40px;
}

.interface_update_p {
  margin: 0;
  line-height: 27px;
  margin-left: 167px;
  margin-top: -40px;
  font-size: 12px;
}

.removeImg {
  position: absolute;
  top: -11px;
  right: -16px;
  font-size: 19px;
  display: inline-block;
  color: #cfcaca;
}

.interface_prize_new {
  /*background: url(../../assets/images/interface_prize_bg.png);*/
  border: 1px solid #FFC100;
  border-radius: 3px;
  background-size: 100% 100%;
  width: 90%;
  margin: 0 auto;
  min-height: 100pt;
  padding-top: 10px;
  box-sizing: border-box;
  /*overflow: hidden;*/
  overflow-x: auto;
}

.interface_prize_new ul {
  width: 360px;
  margin: 0;
  padding: 0;
}

.interface_prize_new li {
  list-style: none;
  float: left;
  width: 71px;
  padding: 10px 6px 0;
  box-sizing: border-box;
}

.interface_prize_new li div {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  border: 1px solid #FFF1AF;
  background: #fff;
  /*padding-top: 12px;*/
  box-sizing: border-box;
  position: relative;
}

.interface_prize_new li div img {
  max-width: 80%;
  max-height: 48px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

.interface_prize_new li p {
  color: #FFF1AF;
  margin: 10px 0 0;
  font-size: 13px;
}

.interface_rule {
  margin-bottom: 20px;
  color: #FFF1AF;
  line-height: 28px;
  height: auto;
  padding: 0 10px;
  text-align: left
}

.mask {
  background: rgba(0, 0, 0, 0.58);
  overflow: hidden !important;
  position: absolute;
  width: 100%;
  height: 547px;
  z-index: 3;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px
}

.interface_prize {
  max-width: 100px;
  max-height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.harvest {
  color: #FD7980;
  background: #fff;
  line-height: 34px;
  width: 79%;
  margin: 0 auto;
  text-align: left;
  padding-left: 8px;
  box-sizing: border-box;
  border-radius: 3px;
}
.harvest_con {
  padding-top: 280px;
  box-sizing: border-box;
}
.interface_altar {
  position: absolute;
  left: 6px;
  top: -23px;
  height: 200px;
}
.interface_altar_open {
  position: absolute;
  left: 47px;
  top: 113px;
  height: 40px;
  width: 40px;
  z-index: 2
}

.qrcode_con {
  margin: 0;
  color: #fff;
  font-size: 12px;
  line-height: 17px;
}

.interface_btn {
  margin-top: 20px !important;
}

.tab-tit ul {
  width: 572px;
  display: block;
  margin: 0 auto;
}
.tab-tit {
text-align: center;
}
.tab-tit ul li {
  list-style: none;
  float: left;
  width: 250px;
  height: 80px;
  position: relative;
  text-align: right;
  padding-top: 11px;
  box-sizing: border-box;
  cursor: pointer;
}

.tab-tit ul li img {
  width: 36px;
  margin-right: 5px;
}

.tab-tit ul li p {
  margin: 0;
  font-size: 12px;
  margin-top: 4px;
}

.tab-tit ul li span {
  position: absolute;
  display: inline-block;
  width: 205px;
  height: 1px;
  background: #C7C7C7;
  top: 30px;
  left: -4px;
}

.tab-tit ul li.cur span {
  background: #1980FF;
}
.tab-con {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.condition-content {
  width: 900px;
}
.higher-search-analyse {
  width: 900px;
  margin: 0 auto;
}
.item-content {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: auto;
  height: 40px;
  line-height: 40px;
}
.radio-content {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  line-height: 40px;
  margin-top: 8px;
}
.radio-content .el-radio {
  margin-right: 0px;
  width: 150px;
}
.select-content .el-select {
  margin-right: 10px;
  /*margin-bottom: 5px;*/
  /*margin-top: 5px;
  margin-bottom: 5px;*/
  /*margin-top: 5px;*/
}
.search-terms-content {
  padding-top: 10px;
  padding-bottom: 10px;
}
.analyse-search-icon {
  color: #1980FF;
}
.higher-search-analyse {
  display: flex;
  align-items: center;
  justify-content: center;
}
.big-terms-content {
  min-width: 940px;
}
@media screen and (max-width: 1669px) {
  .big-terms-content {
  }
}
.term-item {
  margin-bottom: 5px;
}
.finish-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100px;
  margin: 0 auto;
  margin-left: 46%;
  font-size: 20px;
  margin-top: 120px;
  margin-bottom: 120px;
}
.finish-content img {
  width: 100px;
  margin-bottom: 20px;
}
</style>
